export default "__VITE_ASSET__BB4QBb1E__"